import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const focusFn = /* @__PURE__ */ createRecipe('focus', {}, [])

const focusVariantMap = {
  "color": [
    "danger"
  ]
}

const focusVariantKeys = Object.keys(focusVariantMap)

export const focus = /* @__PURE__ */ Object.assign(memo(focusFn.recipeFn), {
  __recipe__: true,
  __name__: 'focus',
  __getCompoundVariantCss__: focusFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: focusVariantKeys,
  variantMap: focusVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, focusVariantKeys)
  },
  getVariantProps: focusFn.getVariantProps,
})